import { signal } from 'services/SignalsService'
import { StoreageService } from 'services/StoreageService'
import { debug } from 'settings/custom/build'
import { mapping } from 'settings/keyboard'
import { noop } from 'utils/Mocks'

const locks = {}

signal.on('POPUP:show', makeLock('popup', true))
signal.on('POPUP:close', makeLock('popup', false))

signal.on('STATE:IN:FB-ADD', makeLock('Space', true))
signal.on('STATE:OUT:FB-ADD', makeLock('Space', false))

const callbacks = { noop }

function makeLock(name, value) {
  return function () {
    locks[name] = value
  }
}

function onSetup() {
  document.addEventListener('keydown', onRegular)
}

function onRegular({ code }) {
  if (Object.values(locks).every((lock) => !lock)) {
    callbacks[process(code)]()
  }
}

function process(code) {
  const key = mapping[code]
  switch (code) {
    case 'Equal': return setTimeScale(+1)
    case 'Minus': return setTimeScale(-1)
    case 'Space': return StoreageService.get('space') ? key : 'noop'
    case 'ArrowLeft': return key[+game.models.ModeModel.auto]
    case 'ArrowRight': return key[+game.models.ModeModel.auto]
  }
  return key || 'noop'
}

export const KeyboardManager = {
  init,
  register,
}

function init() {
  signal.once('STATE:OUT:INIT', onSetup)
}

function register({ id, payload, tap }) {
  const name = `${id}|${payload}`.replace(/\|undefined/, '')
  callbacks[name] = tap
}

function setTimeScale(delta) {
  if (debug) {
    const scale = game.gui.controllers.timeScale
    scale.setValue(scale.getValue() + delta)
  }
  return 'noop'
}
